import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

export const FilledButton = styled(Button, {
  shouldForwardProp: (prop) =>
    prop !== "width" &&
    prop !== "height" &&
    prop !== "backgroundColor" &&
    prop !== "toBeVoted",
})<{
  width?: string;
  height?: string;
  backgroundColor?: string;
  toBeVoted?: boolean;
}>(
  ({
    width = "90px",
    height = "30px",
    backgroundColor = "#B2E8F1",
    toBeVoted = false,
  }) => ({
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    width: width,
    height: height,
    fontSize: "10px",
    fontWeight: "500",
    opacity: "1",
    float: "left",
    maxWidth: "200px",
    padding: "8px 12px",
    backgroundColor: backgroundColor,
    borderRadius: "8px",
    color: "#2E5242",
    textTransform: "none",
    fontFamily: "Roboto",
    marginLeft: toBeVoted ? "10px" : "0px",
    "&:hover": {
      backgroundColor: "#2E5242",
      color: "#B2E8F1",
      boxShadow: " 2px 2px 4px #000000",
    },
  })
);

export const OutlinedButton = styled("button")(({ theme }) => ({
  width: "fit-content",
  height: "fit-content",
  fontSize: "20px",
  lineHeight: "20px",
  fontFamily: "Poppins",
  fontWeight: "700",
  padding: "10px 20px",
  backgroundColor: theme.palette.background.default,
  color: theme.palette.primary.main,
  borderRadius: "8px",
  border: "2px solid",
  borderColor: theme.palette.primary.main,
  boxShadow: "-4px 4px 0px " + theme.palette.primary.main,
  cursor: "pointer",
  "&:hover": {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.background.default,
    boxShadow: "none",
  },

  [theme.breakpoints.down("sm")]: {
    padding: "7px 10px",
  },
}));
